module.exports = __webpack_public_path__ + "img/retail_forum.f93c3d38.png";